<template>
  <div :class="`playlist-group-card playlist-group-card--${segmentType} ${isShort ? 'short' : ''}`">
    <div @click.capture="verifyDemo">
      <a :href="thumbnailLink.href" @click.prevent="$router.push(thumbnailLink.route)">
        <playlist-group-thumbnail
          :playlistGroup="playlistGroup"
          :segmentType="segmentType"
          :backgroundImage="backgroundImage"
          :isInfoOpen="isInfoOpen"
          @mouseenter="isInfoOpen = true"
          @mouseleave="isInfoOpen = false"
          @backgroundImageLoaded="removeBackground"
        />
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'playlist-group-card',
  props: {
    isDemo: {
      type: Boolean,
      default: false
    },
    playlistGroup: {
      type: Object,
      required: true
    },
    segmentType: {
      type: String,
      validator: s => ['smile', 'featured', 'character'].includes(s)
    },
    backgroundImage: {
      type: String,
      required: true
    }
  },
  data: () => ({ isInfoOpen: false }),
  computed: {
    ...mapGetters({ getVideosFromPlaylist: 'contentTree/findVideosFromPlaylist' }),
    isShort() {
      return this.thumbnailLink.name === 'watch-video'
    },
    thumbnailLink() {
      if (this.playlistGroup.playlists.length === 1) {
        const playlist = this.playlistGroup.playlists[0]
        const videos = this.getVideosFromPlaylist(playlist)
        if (videos.length === 1) {
          return this.$router.resolve({
            name: 'watch-video',
            params: {
              id: videos[0].id,
              playlistId: playlist,
              playlistGroupId: this.playlistGroup.id
            }
          })
        }
      }

      return this.$router.resolve({
        name: 'playlist-group-view',
        params: {
          id: this.playlistGroup.id
        }
      })
    }
  },
  methods: {
    verifyDemo(evt) {
      if (this.isDemo) {
        evt.preventDefault()
        evt.stopPropagation()
        this.$emit('demoActivated')
      }
    },
    removeBackground(evt) {
      evt.target.parentNode.classList.add('playlist-group-thumbnail--loaded')
    }
  }
}
</script>

<style lang="scss">
.playlist-group-card {
  padding: 0 32px 0 0;
  transition: transform 0.3s;

  &:last-child {
    padding-right: 0;
  }

  &:hover {
    transform: scale(1.15);

    .playlist-group-thumbnail {
      box-shadow: 0px 8px 24px rgba(82, 53, 167, 0.15);
    }
  }

  &--featured {
    &:hover {
      transform: scale(1.1);
    }

    .playlist-group-thumbnail {
      width: 320px;
      height: 482px;
    }
  }

  &--smile {
    display: inline-block;
    overflow: visible;

    &:hover {
      transform: translateY(-6px);

      .playlist-group-thumbnail {
        box-shadow: 0px 8px 26px rgba(82, 53, 167, 0.22);
      }

      & ~ .playlist-group {
        transform: none;
      }
    }

    .playlist-group-thumbnail {
      transition: box-shadow 0.3s;
      border-radius: 98px;
      width: 196px;
      height: 196px;
      box-shadow: 0px 8px 24px rgba(82, 53, 167, 0.15);
    }
  }

  &.short .info > div > h2 {
    margin-bottom: 0;
  }

  @media (hover: none),
         (max-width: 425px) and (orientation: portrait),
         (max-width: 812px) and (orientation: landscape) {
    padding: 0 16px 0 0;

    &:last-child {
      padding-right: 16px;
    }

    &:hover {
      transform: none;
    }

    &--smile {
      &:hover {
        transform: none;
      }

      .playlist-group-thumbnail {
        width: 98px;
        height: 98px;
      }
    }

    &--featured {
      &:hover {
        transform: none;
      }

      .playlist-group-thumbnail {
        width: 160px;
        height: 241px;
      }
    }
  }
}
</style>
